/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Order_Carrier_Delivery_Failed_TitleInputs */

const vi_order_carrier_delivery_failed_title = /** @type {(inputs: Order_Carrier_Delivery_Failed_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đơn vị vận chuyển báo giao thất bại`)
};

/**

* @param {Order_Carrier_Delivery_Failed_TitleInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const order_carrier_delivery_failed_title = /** @type {((inputs?: Order_Carrier_Delivery_Failed_TitleInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Order_Carrier_Delivery_Failed_TitleInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_order_carrier_delivery_failed_title(inputs)
});